<template>
    <div class="container-fluid mb-5 ps-5">
        <div class="row">
            <div class="col">
                <img @click="$emit('go-back-event')" src="../../assets/back-button.svg" class="img-fluid cursor-pointer" width="32" alt="">
            </div>
        </div>
    </div>

    <div class="custom-container">
        <div class="row mb-3">
            <div class="col">
                <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/482776608?h=41c3eac54e&title=0&byline=0&portrait=0&speed=0&badge=0&autopause=0&player_id=0&app_id=58479/embed" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen frameborder="0" style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe></div>
            </div>
        </div>
        <div class="row">
            <div class="text-center mb-3">
                <input @click="$emit('go-to-event', 'InfoScreenId')" type="submit" value="Skip video">
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'VideoScreen',
        emits: ['go-to-event', 'go-back-event'],
    }
</script>